import { Navigate } from 'react-router-dom'

import { AdminFormLayout, AdminPage, AdminPageHeader, AdminSection } from '../../common/components'
import { useDashboard } from '../../common/hooks'
import { GlobalPathEnum } from '../../common/types/routing'
import CompanyCreation from './CompanyCreation'

const CompanyCreationAdminPanelPage = () => {
  const { user } = useDashboard()

  if (!user.isSuperuser) {
    return <Navigate to={GlobalPathEnum.NOT_FOUND} replace />
  }

  return (
    <AdminPage width='wide'>
      <AdminPageHeader
        title='Add Company'
        description='Create a new company entry and define its initial setup parameters.'
      />
      <AdminFormLayout width='narrow'>
        <AdminSection className='space-y-4'>
          <CompanyCreation />
        </AdminSection>
      </AdminFormLayout>
    </AdminPage>
  )
}

export default CompanyCreationAdminPanelPage

